import { render, staticRenderFns } from "./flashcash.vue?vue&type=template&id=6972a9d8&scoped=true"
import script from "./flashcash.vue?vue&type=script&lang=js"
export * from "./flashcash.vue?vue&type=script&lang=js"
import style0 from "./flashcash.vue?vue&type=style&index=0&id=6972a9d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6972a9d8",
  null
  
)

export default component.exports